module.exports = __webpack_public_path__ + "static/media/DSCF0072.9c3aae84.jpg";